'use client'
import FabricCanvasTool from '../fabrictool'
class Pan extends FabricCanvasTool {
  configureCanvas() {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    canvas.defaultCursor = `pointer`
  }

  doMouseDown(o) {

    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    this.isDown = true
    const pointer = canvas.getPointer(o.e)
    this.startX = pointer.x
    this.startY = pointer.y
  }

  doMouseMove(o) {
    if (!this.isDown) return
    const canvas = this._canvas
    const pointer = canvas.getPointer(o.e)
    const x=  pointer.x - this.startX
    const y=  pointer.y - this.startY

    if(canvas.backgroundImage && canvas.backgroundImage.lineCoords &&
       canvas.backgroundImage.lineCoords.br.x +x >=300 &&
        canvas.backgroundImage.lineCoords.bl.x +x <=canvas.width -300 &&
        canvas.backgroundImage.lineCoords.bl.y +y >=300 &&
        canvas.backgroundImage.lineCoords.tl.y +y <=canvas.height -300
      )
    {
      canvas.relativePan({
        x: pointer.x - this.startX,
        y: pointer.y - this.startY
      })
      canvas.renderAll()
    }

  }

  doMouseUp() {
    this.isDown = false
  }
}

export default Pan
